import { render, staticRenderFns } from "./ShieldExclamationIcon.vue?vue&type=template&id=be08e5b2&"
import script from "./ShieldExclamationIcon.vue?vue&type=script&lang=js&"
export * from "./ShieldExclamationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports